var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-action-button',{attrs:{"icon":"mdi-email-send","label":"Send test message","text":""},on:{"click":function($event){return _vm.exec(_vm.item)}}})}
var staticRenderFns = []

export { render, staticRenderFns }